import * as React        from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown}   from "@fortawesome/free-solid-svg-icons";

import "./property-data-card.scss";
import "./custom-state-selector.scss";

import {cs}                from "@Common/react/chain-services";
import {UseState}            from "@Common/react/use-state";

export const CustomStateSelector = ({propertyData, propertyDataChangeHandler}) => cs(
    ["states", ({}, next) => next([
        {value: "AL", label: "AL"},
        {value: "AK", label: "AK"},
        {value: "AZ", label: "AZ"},
        {value: "AR", label: "AR"},
        {value: "CA", label: "CA"},
        {value: "CO", label: "CO"},
        {value: "CT", label: "CT"},
        {value: "DE", label: "DE"},
        {value: "DC", label: "DC"},
        {value: "FL", label: "FL"},
        {value: "GA", label: "GA"},
        {value: "HI", label: "HI"},
        {value: "ID", label: "ID"},
        {value: "IL", label: "IL"},
        {value: "IN", label: "IN"},
        {value: "IA", label: "IA"},
        {value: "KS", label: "KS"},
        {value: "KY", label: "KY"},
        {value: "LA", label: "LA"},
        {value: "ME", label: "ME"},
        {value: "MD", label: "MD"},
        {value: "MA", label: "MA"},
        {value: "MI", label: "MI"},
        {value: "MN", label: "MN"},
        {value: "MS", label: "MS"},
        {value: "MO", label: "MO"},
        {value: "MT", label: "MT"},
        {value: "NE", label: "NE"},
        {value: "NV", label: "NV"},
        {value: "NH", label: "NH"},
        {value: "NJ", label: "NJ"},
        {value: "NM", label: "NM"},
        {value: "NY", label: "NY"},
        {value: "NC", label: "NC"},
        {value: "ND", label: "ND"},
        {value: "OH", label: "OH"},
        {value: "OK", label: "OK"},
        {value: "OR", label: "OR"},
        {value: "PA", label: "PA"},
        {value: "RI", label: "RI"},
        {value: "SC", label: "SC"},
        {value: "SD", label: "SD"},
        {value: "TN", label: "TN"},
        {value: "TX", label: "TX"},
        {value: "UT", label: "UT"},
        {value: "VT", label: "VT"},
        {value: "VA", label: "VA"},
        {value: "WA", label: "WA"},
        {value: "WV", label: "WV"},
        {value: "WI", label: "WI"},
        {value: "WY", label: "WY"},
    ])],
    ["selectedState", ({}, next) => UseState({
        initValue: propertyData?.value?.state ?? "",
        next,
    })],
    ["handleSelection", ({selectedState, propertyData}, next) => next((option) => {
        const syntheticEvent = {
            target: { name: "state", value: option },
            preventDefault: () => {},
            stopPropagation: () => {},
        };
        selectedState.onChange(option);
        propertyDataChangeHandler(syntheticEvent);
    })],
    ["isOpen", ({}, next) => UseState({
        initValue: false,
        next,
    })],

    ({states, selectedState, isOpen, handleSelection}) => (
        <div className="custom-state-selector-j73"
            tabIndex={0}
            onClick={() => isOpen.onChange(!isOpen.value)}
            onBlur={() => isOpen.onChange(false)}
        >
            <div className="selector-container">
                <input
                    type="text"
                    name="state"
                    className="state-value"
                    readOnly={true}
                    value={selectedState.value}
                    placeholder="State"
                    xd-qa-type="text_field"
                    xd-qa-name="State"
                />
                <div className="icon">
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>
            </div>
            <div className="options-container">
                {isOpen.value && (
                    <div className="options"
                        tabIndex={0}
                    >
                        {states.map((option) => (
                            <div
                                key={option.value}
                                className={`option ${selectedState === option.value ? "selected" : ""}`}
                                tabIndex={0}
                                // have to use onMouseDown instead of onClick to prevent the dropdown from closing
                                // mousedown accurs before the blur event of previously focusd element
                                onMouseDown={() => handleSelection(option.value)}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
)